module.exports = __webpack_public_path__ + "static/media/add-grey.c7607772.svg";